module.exports = __webpack_public_path__ + "static/media/stm-call.3dfb3acb.svg";